import script from "./FormularioDatosFiscales.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioDatosFiscales.vue?vue&type=script&setup=true&lang=js"

import "./FormularioDatosFiscales.vue?vue&type=style&index=0&id=5c0eb72b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c0eb72b"]])

export default __exports__